import { Component }             from '@angular/core';
import { NavController }         from 'ionic-angular';
import { MenuController }        from 'ionic-angular';
import { TranslateService }      from '@ngx-translate/core';

import { CompensatedVacuumPage } from '../compensated-vacuum/compensated-vacuum';
import { GasFlushingPage }       from '../gas-flushing/gas-flushing';
import { GoogleAnalytics } from '@ionic-native/google-analytics';

@Component({
  selector:     'page-gascomsuption',
  templateUrl:  'gascomsuption.html'
})

export class GascomsuptionPage
{
  items     : Array<{title: string, page: any, icon: string, background: string, overlay: string}>;
  vaccum    : string = 'Compensated vacuum machine';
  flushing  : string = 'Gas flushing machine';

  constructor(public navCtrl   : NavController,
              public menuCtrl  : MenuController,
              public translate : TranslateService,
              private analytics  : GoogleAnalytics)
  {
    this.items  = [];
  
    this.initUnitTranslation();

    this.items.push(
      {
        title:      this.vaccum,
        page:       CompensatedVacuumPage,
        icon:       '',
        background: 'assets/vacuum.png',
        overlay:    ''
      });

    this.items.push(
      {
        title:      this.flushing,
        page:       GasFlushingPage,
        icon:       '',
        background: 'assets/flushing.png',
        overlay:    ''
      });
  }

  ionViewDidLoad()
  {
    this.analytics.trackView("Gas Comsumption");
  }
  
  initUnitTranslation()
  {
    var context = this;

    this.translate.get('COMPENSATED').subscribe(
      value => {
        context.vaccum = value;
      })

    this.translate.get('FLUSHING').subscribe(
      value => {
        context.flushing = value;
      })
  }

  toggleMenu()
  {
    this.menuCtrl.toggle();
  }

  backAction()
  {
    this.navCtrl.pop({animate: false});
  }

  itemTapped(event, item)
  {
    this.navCtrl.push(item.page, {}, {animate: false});
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/gascomsuption/gascomsuption.ts